import Blue from "~/core";

new Blue({
	name: 'Accordion',
	selector: ".accordion",
	setup(accordion) {
		let items = accordion.querySelectorAll('.accordion__item');
		const relations = [];

		items.forEach(item => {
			let trigger = item.querySelector('.accordion__trigger');
			let content = item.querySelector('.accordion__content');
	
			let config = {
				trigger,
				content,
				relations
			}
			relations.push(new this.$toggle(config));
	
			this.$addEvents(content, 'click.stop enter.stop', () => false);
	
		})
	}
});